import $window from './window';
import { getBrandContext } from './utils';

/**
 * Supplements provided data object with valueTierFlag derived from tealium_va.
 * Non-destructive: returns a new object; only sets when a value exists.
 * @param {Object} data
 * @param {Object} [options]
 * @param {string} [options.brand] - Current site brand (anf | hol | kids | gh | st)
 * @returns {Object}
 */
export function supplementPltvInfo(data = {}, { brand } = {}) {
  const newData = { ...data };

  // Safely parse tealium_va
  let tealiumVa;
  try {
    const raw = $window?.localStorage?.getItem('tealium_va');
    tealiumVa = raw ? JSON.parse(raw) : null;
  } catch (_) {
    tealiumVa = null;
  }

  if (!tealiumVa || typeof tealiumVa !== 'object') return newData;

  // Determine brand key for mapping
  let brandKey = brand;
  if (!brandKey) {
    const ctx = getBrandContext();
    brandKey = ctx === 'hol' ? 'hco' : 'anf';
  } else if (brandKey === 'hol') {
    brandKey = 'hco';
  }

  const pltvPropertiesMap = {
    anf: '11267',
    kids: '11311',
    hco: '11299',
    gh: '11313',
    st: '',
  };

  const property = pltvPropertiesMap[brandKey];
  const props = tealiumVa?.properties || {};
  const pltvValue = property ? props[property] : undefined;

  if (pltvValue) {
    newData.valueTierFlag = pltvValue;
  }

  return newData;
}

export default supplementPltvInfo;
